import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { setCreatedData } from '../../../../ReduxToolkit/Reducers/ProjectSlice';
import { Col, FormGroup, Label, Row } from 'reactstrap'
import ButtonSection from '../ProjectCreate/ButtonSection';
import Swal from 'sweetalert2';
import api from '../../../../utils/api';

import React, { useEffect, useState } from 'react';

const FoodForm = () => {
    const navigate = useNavigate();
    const { createdFormData } = useAppSelector((state) => state.project);
    const dispatch = useAppDispatch();

    const [categories, setCategories] = useState<any[]>([]);

    const [formData, setFormData] = useState({
        foodCategoryId:"",
        sellingprice:"",
        discountprice: "",
        foodname:"",
        images: "",
      });
    
      const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };

    useEffect(() => {
      const fetchCategories = async () => {
        try {
          const response = await api.get('/api/FoodCategory/GetAllFoodCategory');
          if (response.status === 200) {
            setCategories(response.data);
          }
        } catch (error) {
          setCategories([]);
        }
      };
      fetchCategories();
    }, []);
  
    const projectSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
         e.preventDefault();
      const submittedData = {
        foodMasterId: 0,
        foodCategoryId: Number(formData.foodCategoryId),
        foodname: formData.foodname,
        sellingprice: Number(formData.sellingprice),
        foodprice: Number(formData.discountprice),
        images: formData.images ? formData.images : "", 
      };
      if (!submittedData.foodCategoryId || !submittedData.foodname || !submittedData.sellingprice) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please fill all the required fields.',
        });
        return; // Stop submission if validation fails
      }
      if (isNaN(submittedData.sellingprice) || submittedData.sellingprice <= 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please enter a valid selling price.',
        });
        return; // Stop submission if validation fails
      }
      if (isNaN(submittedData.foodprice) || submittedData.foodprice < 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please enter a valid MRP.',
        });
        return; // Stop submission if validation fails
      }
      dispatch(setCreatedData([...createdFormData, submittedData]));
      try {
        const response = await api.post('/api/FoodMaster/AddFoodMaster', submittedData, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          dispatch(setCreatedData([...createdFormData, response.data]));
    
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Food created successfully.',
          }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/food/foodList`);
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'Something went wrong while creating the food.',
        });
      }
    };
    return (
        <form className="theme-form" onSubmit={projectSubmit}>
            <Row>
                <Col sm="4">
                    <FormGroup>
                        <Label check>Category</Label>
                        <select name="foodCategoryId" className="form-control form-select" value={formData.foodCategoryId}
              onChange={handleChange} required={true}>
                        <option value="">Select Category</option>
                        {/* Category options */}
                        {categories.map((cat: any) => (
                            <option key={cat.foodCategoryId} value={cat.foodCategoryId}>
                            {cat.categoryName}
                            </option>
                        ))}
                        </select>
                    </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>Food Name</Label>
                    <input name="foodname" type="text" className="form-control" value={formData.foodname}
              onChange={handleChange} placeholder="Enter food name here..." required={true} />
                </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>Food Selling Price</Label>
                    <input name="sellingprice" className="form-control" value={formData.sellingprice}
              onChange={handleChange} type="number" placeholder="Enter food selling price here..." required={true} />
                </FormGroup>
                </Col>
                <Col sm="4">
                <FormGroup>
                    <Label check>MRP</Label>
                    <input name="discountprice" className="form-control" value={formData.discountprice}
              onChange={handleChange} type="number" placeholder="Enter  MRP here..." />
                </FormGroup>
                </Col>
                <Col sm="4"> 
                <FormGroup>
                    <Label check>Image</Label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={async (e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                    const result = reader.result as string;
                                    // Remove data URL prefix if present
                                    const base64 = result.includes(',') ? result.split(',')[1] : result;
                                    setFormData(prev => ({
                                        ...prev,
                                        images: base64
                                    }));
                                };
                                reader.readAsDataURL(file);
                            }
                        }}
                        required={true}
                    />
                </FormGroup>
                </Col>
                <Col sm="4" className='mt-4'>
                    <ButtonSection cancel_url={`/food/foodList`} />
                </Col>
            </Row>
        
        </form>
    )
}

export default FoodForm